export const FormSamplesValidationPageInfo = () => {
    return (
        <>
            This shows the different types of validation that can be done.<br />
            The bottom example shows how you can impliment your own custom validation.
        </>
    )
}
